import { Grid, Tab, Tabs } from '@material-ui/core'
import React, { useState } from 'react'
import { useStyles } from './work-list-tabs'
import { wlViewTabs } from './const'
import { a11yProps } from 'asterX-UI/Tabs'
import { useWorkListViewSppStore } from 'context/WorkListViewStore/SPP/WorkListViewStore.spp'
import AsterButton from 'asterX-UI/Buttons/AsterButton'
import ActionModal from 'asterX-UI/Modals/ActionModal'

export const SppWorkListTabs = () => {
  const classes = useStyles()

  const {
    store: { wlData },
    actions: { handleApproveSpp }
  } = useWorkListViewSppStore()

  const [tab, setTab] = useState(0)
  const [approveSpp, setApproveSpp] = useState(false)
  const [refuseSpp, setRefuseSpp] = useState(false)

  const TabBody = wlViewTabs[tab].component

  return (
    <Grid container>
      {!wlData?.sppApprove &&
        ['110'].includes(wlData?.saleStatusTrack?.code) && (
          <Grid
            item
            container
            alignItems="center"
            justifyContent="flex-start"
            spacing={2}
            md={6}
            xs={12}
          >
            <Grid item md={6} xs={12}>
              <AsterButton
                fullWidth
                color="negative"
                onClick={() => setRefuseSpp(true)}
              >
                Отказать
              </AsterButton>
            </Grid>
            <Grid item md={6} xs={12}>
              <AsterButton
                fullWidth
                color="primary"
                onClick={() => setApproveSpp(true)}
              >
                Согласовать
              </AsterButton>
            </Grid>
          </Grid>
        )}
      <Grid item container style={{ marginBottom: 24 }}>
        <Tabs
          className={classes.wlViewTabs}
          value={tab}
          onChange={(e, value) => setTab(value)}
        >
          {wlViewTabs.map(({ label }, i) => (
            <Tab
              key={`wl-view-tab-${i}`}
              label={label}
              value={i}
              {...a11yProps(i)}
            />
          ))}
        </Tabs>
      </Grid>
      <Grid item container>
        <TabBody {...(wlData || {})} />
      </Grid>
      <ActionModal
        title="Согласовать?"
        open={approveSpp}
        onClose={() => setApproveSpp(false)}
        onCancel={() => setApproveSpp(false)}
        onConfirm={() => {
          setApproveSpp(false)
          handleApproveSpp(true)
        }}
      />
      <ActionModal
        title="Отказать?"
        open={refuseSpp}
        onClose={() => setRefuseSpp(false)}
        onCancel={() => setRefuseSpp(false)}
        onConfirm={() => {
          setRefuseSpp(false)
          handleApproveSpp(false)
        }}
      />
    </Grid>
  )
}
